/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  Bdkv2RetrieveBookProceduresResponse,
  Bdkv2RetrieveBookResponse,
  Bdkv2RetrieveBooksResponse,
  Bdkv2RetrieveDiscoverablesResponse,
  Bdkv2RetrieveTagsResponse,
  Bdkv2RetrieveUserInfoResponse,
  LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody,
  LibraryServiceAddWorkspaceBookConnectionBody,
  LibraryServiceAddWorkspaceBookConnectionPollInstanceBody,
  LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody,
  LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody,
  LibraryServiceAssociateRemoteConnectionBody,
  LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody,
  LibraryServiceReactivateWorkspaceBookConnectionBody,
  LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody,
  LibraryServiceSearchWorkspaceBookConceptsBody,
  LibraryServiceSearchWorkspaceBookConnectionProceduresBody,
  LibraryServiceSearchWorkspaceBookProceduresBody,
  LibraryServiceSearchWorkspaceBooksBody,
  LibraryServiceSetAutomationsForPollInstanceBody,
  LibraryServiceSetAutomationsForTriggerInstanceBodyBody,
  LibraryServiceSetDiscoveredBody,
  LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody,
  LibraryServiceUpdateWorkspaceBookConnectionBody,
  LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody,
  LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody,
  LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody,
  LibraryServiceUpgradeWorkspaceBookConnectionBody,
  LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody,
  RetrieveAllWorkspaceBookConnectionsParams,
  RetrieveBooksParams,
  RetrieveLatestBooksParams,
  RetrieveLatestWorkspaceBooksParams,
  RetrieveWorkspaceAgentTriggerInstancesParams,
  RetrieveWorkspaceBookConnectionDiscoverablesParams,
  RetrieveWorkspaceBookConnectionProceduresParams,
  RetrieveWorkspaceBookConnectionsParams,
  RetrieveWorkspaceBooksParams,
  RetrieveWorkspacePollInstancesParams,
  RetrieveWorkspaceTriggerInstancesParams,
  RpcStatus,
  V2AddWorkspaceBookConnectionAgentTriggerInstanceResponse,
  V2AddWorkspaceBookConnectionPollInstanceResponse,
  V2AddWorkspaceBookConnectionTriggerInstanceResponse,
  V2BookConnectionResponse,
  V2DiscoverWorkspaceBookConnectionProceduresResponse,
  V2RemoveBookConnectionResponse,
  V2RemoveWorkspaceBookConnectionAgentTriggerInstanceResponse,
  V2RemoveWorkspaceBookConnectionPollInstanceResponse,
  V2RemoveWorkspaceBookConnectionRequest,
  V2RemoveWorkspaceBookConnectionTriggerInstanceResponse,
  V2RetrieveBookConceptsResponse,
  V2RetrieveBookConnectionResponse,
  V2RetrieveBookConnectionsResponse,
  V2RetrieveBookVersionsResponse,
  V2RetrieveBooksConnectionsResponse,
  V2RetrieveWorkspaceAgentTriggerInstancesResponse,
  V2RetrieveWorkspacePollInstancesResponse,
  V2RetrieveWorkspaceTriggerInstancesResponse,
  V2SearchBookConceptsRequest,
  V2SearchBookConceptsResponse,
  V2SearchBookProceduresRequest,
  V2SearchBookProceduresResponse,
  V2SearchBooksRequest,
  V2SearchBooksResponse,
  V2SearchWorkspaceBookProceduresResponse,
  V2SetAutomationsForPollInstanceResponse,
  V2SetAutomationsForTriggerInstanceResponse,
  V2UpdateWorkspaceBookConnectionAgentTriggerInstanceResponse,
  V2UpdateWorkspaceBookConnectionPollInstanceResponse,
  V2UpdateWorkspaceBookConnectionTriggerInstanceResponse,
} from '../../models';

/**
 * This endpoint returns metadata for all books that are currently available
in the runtime, including their names, versions, descriptions, authentication
requirements, and capabilities.
 * @summary Retrieves a list of all available books in the library.
 */
export const retrieveBooks = (
  params?: RetrieveBooksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBooksResponse>> => {
  return axios.default.get(`/api/v1/books`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getRetrieveBooksQueryKey = (params?: RetrieveBooksParams) => {
  return [`/api/v1/books`, ...(params ? [params] : [])] as const;
};

export const getRetrieveBooksQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBooks>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveBooksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBooks>>> = ({
    signal,
  }) => retrieveBooks(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveBooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveBooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBooks>>
>;
export type RetrieveBooksQueryError = AxiosError<RpcStatus>;

export function useRetrieveBooks<
  TData = Awaited<ReturnType<typeof retrieveBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | RetrieveBooksParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBooks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBooks<
  TData = Awaited<ReturnType<typeof retrieveBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBooks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBooks<
  TData = Awaited<ReturnType<typeof retrieveBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBooks>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves a list of all available books in the library.
 */

export function useRetrieveBooks<
  TData = Awaited<ReturnType<typeof retrieveBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBooks>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveBooksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of all version strings available for the
specified book name.
 * @summary Retrieves all available versions for a specific book.
 */
export const retrieveBookVersions = (
  name: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookVersionsResponse>> => {
  return axios.default.get(`/api/v1/books/${name}/versions`, options);
};

export const getRetrieveBookVersionsQueryKey = (name?: string) => {
  return [`/api/v1/books/${name}/versions`] as const;
};

export const getRetrieveBookVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveBookVersionsQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveBookVersions>>
  > = ({ signal }) => retrieveBookVersions(name, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveBookVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveBookVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBookVersions>>
>;
export type RetrieveBookVersionsQueryError = AxiosError<RpcStatus>;

export function useRetrieveBookVersions<
  TData = Awaited<ReturnType<typeof retrieveBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookVersions>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookVersions<
  TData = Awaited<ReturnType<typeof retrieveBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookVersions>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookVersions<
  TData = Awaited<ReturnType<typeof retrieveBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available versions for a specific book.
 */

export function useRetrieveBookVersions<
  TData = Awaited<ReturnType<typeof retrieveBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveBookVersionsQueryOptions(name, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint provides comprehensive metadata about a particular book,
including its description, author, icon, authentication mechanisms,
configuration parameters, and capabilities.
 * @summary Retrieves detailed information about a specific book version.
 */
export const retrieveBook = (
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBookResponse>> => {
  return axios.default.get(`/api/v1/books/${name}/${version}`, options);
};

export const getRetrieveBookQueryKey = (name?: string, version?: string) => {
  return [`/api/v1/books/${name}/${version}`] as const;
};

export const getRetrieveBookQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveBook>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBook>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveBookQueryKey(name, version);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBook>>> = ({
    signal,
  }) => retrieveBook(name, version, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveBook>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveBookQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBook>>
>;
export type RetrieveBookQueryError = AxiosError<RpcStatus>;

export function useRetrieveBook<
  TData = Awaited<ReturnType<typeof retrieveBook>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBook>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBook>>,
          TError,
          Awaited<ReturnType<typeof retrieveBook>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBook<
  TData = Awaited<ReturnType<typeof retrieveBook>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBook>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBook>>,
          TError,
          Awaited<ReturnType<typeof retrieveBook>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBook<
  TData = Awaited<ReturnType<typeof retrieveBook>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBook>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves detailed information about a specific book version.
 */

export function useRetrieveBook<
  TData = Awaited<ReturnType<typeof retrieveBook>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveBook>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveBookQueryOptions(name, version, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of concept descriptors defined by the
specified book, which can be referenced by procedures as inputs or outputs.
 * @summary Retrieves all available concepts for the specified book version.
 */
export const retrieveBookConcepts = (
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookConceptsResponse>> => {
  return axios.default.get(
    `/api/v1/books/${name}/${version}/concepts`,
    options,
  );
};

export const getRetrieveBookConceptsQueryKey = (
  name?: string,
  version?: string,
) => {
  return [`/api/v1/books/${name}/${version}/concepts`] as const;
};

export const getRetrieveBookConceptsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveBookConceptsQueryKey(name, version);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveBookConcepts>>
  > = ({ signal }) =>
    retrieveBookConcepts(name, version, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveBookConcepts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveBookConceptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBookConcepts>>
>;
export type RetrieveBookConceptsQueryError = AxiosError<RpcStatus>;

export function useRetrieveBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookConcepts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookConcepts>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookConcepts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookConcepts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookConcepts>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookConcepts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available concepts for the specified book version.
 */

export function useRetrieveBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveBookConceptsQueryOptions(
    name,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of all procedures (functions/operations) that
can be invoked on the specified book, along with their signatures, input/output
parameters, and metadata such as descriptions and examples.
 * @summary Retrieves all available procedures for the specified book version.
 */
export const retrieveBookProcedures = (
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBookProceduresResponse>> => {
  return axios.default.get(
    `/api/v1/books/${name}/${version}/procedures`,
    options,
  );
};

export const getRetrieveBookProceduresQueryKey = (
  name?: string,
  version?: string,
) => {
  return [`/api/v1/books/${name}/${version}/procedures`] as const;
};

export const getRetrieveBookProceduresQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveBookProceduresQueryKey(name, version);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveBookProcedures>>
  > = ({ signal }) =>
    retrieveBookProcedures(name, version, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveBookProcedures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveBookProceduresQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBookProcedures>>
>;
export type RetrieveBookProceduresQueryError = AxiosError<RpcStatus>;

export function useRetrieveBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveBookProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveBookProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available procedures for the specified book version.
 */

export function useRetrieveBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveBookProceduresQueryOptions(
    name,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns metadata for all books that are currently available
in the runtime, including their names, versions, descriptions, authentication
requirements, and capabilities.
 * @summary Retrieves a list of all available books in the library.
 */
export const retrieveLatestBooks = (
  params?: RetrieveLatestBooksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBooksResponse>> => {
  return axios.default.get(`/api/v1/books:latest`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getRetrieveLatestBooksQueryKey = (
  params?: RetrieveLatestBooksParams,
) => {
  return [`/api/v1/books:latest`, ...(params ? [params] : [])] as const;
};

export const getRetrieveLatestBooksQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveLatestBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveLatestBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetrieveLatestBooksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveLatestBooks>>
  > = ({ signal }) => retrieveLatestBooks(params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveLatestBooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveLatestBooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLatestBooks>>
>;
export type RetrieveLatestBooksQueryError = AxiosError<RpcStatus>;

export function useRetrieveLatestBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params: undefined | RetrieveLatestBooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLatestBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveLatestBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveLatestBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveLatestBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLatestBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveLatestBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveLatestBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveLatestBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves a list of all available books in the library.
 */

export function useRetrieveLatestBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  params?: RetrieveLatestBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveLatestBooksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns ranked books that best match the provided query.
Each result includes a full book descriptor and a relevance score.
 * @summary Searches books across the library.
 */
export const searchBooks = (
  v2SearchBooksRequest: V2SearchBooksRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchBooksResponse>> => {
  return axios.default.post(
    `/api/v1/books:search`,
    v2SearchBooksRequest,
    options,
  );
};

export const getSearchBooksMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBooks>>,
    TError,
    { data: V2SearchBooksRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBooks>>,
  TError,
  { data: V2SearchBooksRequest },
  TContext
> => {
  const mutationKey = ['searchBooks'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBooks>>,
    { data: V2SearchBooksRequest }
  > = props => {
    const { data } = props ?? {};

    return searchBooks(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBooks>>
>;
export type SearchBooksMutationBody = V2SearchBooksRequest;
export type SearchBooksMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches books across the library.
 */
export const useSearchBooks = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchBooks>>,
      TError,
      { data: V2SearchBooksRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchBooks>>,
  TError,
  { data: V2SearchBooksRequest },
  TContext
> => {
  const mutationOptions = getSearchBooksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns ranked concepts that best match the provided query.
Each result includes the owning book name, version, a full concept descriptor, and a relevance score.
 * @summary Searches concepts across the library.
 */
export const searchBookConcepts = (
  v2SearchBookConceptsRequest: V2SearchBookConceptsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchBookConceptsResponse>> => {
  return axios.default.post(
    `/api/v1/concepts:search`,
    v2SearchBookConceptsRequest,
    options,
  );
};

export const getSearchBookConceptsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBookConcepts>>,
    TError,
    { data: V2SearchBookConceptsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBookConcepts>>,
  TError,
  { data: V2SearchBookConceptsRequest },
  TContext
> => {
  const mutationKey = ['searchBookConcepts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBookConcepts>>,
    { data: V2SearchBookConceptsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchBookConcepts(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBookConceptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBookConcepts>>
>;
export type SearchBookConceptsMutationBody = V2SearchBookConceptsRequest;
export type SearchBookConceptsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches concepts across the library.
 */
export const useSearchBookConcepts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchBookConcepts>>,
      TError,
      { data: V2SearchBookConceptsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchBookConcepts>>,
  TError,
  { data: V2SearchBookConceptsRequest },
  TContext
> => {
  const mutationOptions = getSearchBookConceptsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retrieve all agent trigger instances for a workspace.
 */
export const retrieveWorkspaceAgentTriggerInstances = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveWorkspaceAgentTriggerInstancesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/agent-triggers`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceAgentTriggerInstancesQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/agent-triggers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceAgentTriggerInstancesQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceAgentTriggerInstancesQueryKey(
      organizationId,
      workspaceId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>
  > = ({ signal }) =>
    retrieveWorkspaceAgentTriggerInstances(
      organizationId,
      workspaceId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceAgentTriggerInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>
>;
export type RetrieveWorkspaceAgentTriggerInstancesQueryError =
  AxiosError<RpcStatus>;

export function useRetrieveWorkspaceAgentTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveWorkspaceAgentTriggerInstancesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceAgentTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceAgentTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve all agent trigger instances for a workspace.
 */

export function useRetrieveWorkspaceAgentTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceAgentTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceAgentTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceAgentTriggerInstancesQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns metadata for all books that are currently available
in the runtime for the specified workspace, including their names, versions,
descriptions, authentication requirements, and capabilities.
 * @summary Retrieves a list of all available books in the library for a workspace.
 */
export const retrieveWorkspaceBooks = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceBooksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBooksResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceBooksQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveWorkspaceBooksParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceBooksQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBooksQueryKey(organizationId, workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBooks>>
  > = ({ signal }) =>
    retrieveWorkspaceBooks(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBooks>>
>;
export type RetrieveWorkspaceBooksQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveWorkspaceBooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves a list of all available books in the library for a workspace.
 */

export function useRetrieveWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBooksQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of all connections of a book version.
 * @summary Retrieve connections of a book version.
 */
export const retrieveWorkspaceBookConnections = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookConnectionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceBookConnectionsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  bookName?: string,
  bookVersion?: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceBookConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConnectionsQueryKey(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConnections(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && bookName && bookVersion),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>
>;
export type RetrieveWorkspaceBookConnectionsQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params: undefined | RetrieveWorkspaceBookConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve connections of a book version.
 */

export function useRetrieveWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  params?: RetrieveWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookConnectionsQueryOptions(
    organizationId,
    workspaceId,
    bookName,
    bookVersion,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint adds a new book connection, which can be used to invoke
procedures on the book.
 * @summary Adds a new book connection to the library.
 */
export const addWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  libraryServiceAddWorkspaceBookConnectionBody: LibraryServiceAddWorkspaceBookConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections`,
    libraryServiceAddWorkspaceBookConnectionBody,
    options,
  );
};

export const getAddWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addWorkspaceBookConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      data: LibraryServiceAddWorkspaceBookConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    data: LibraryServiceAddWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['addWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addWorkspaceBookConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      data: LibraryServiceAddWorkspaceBookConnectionBody;
    }
  > = props => {
    const { organizationId, workspaceId, bookName, bookVersion, data } =
      props ?? {};

    return addWorkspaceBookConnection(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addWorkspaceBookConnection>>
>;
export type AddWorkspaceBookConnectionMutationBody =
  LibraryServiceAddWorkspaceBookConnectionBody;
export type AddWorkspaceBookConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Adds a new book connection to the library.
 */
export const useAddWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addWorkspaceBookConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        data: LibraryServiceAddWorkspaceBookConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    data: LibraryServiceAddWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationOptions = getAddWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Adds a book connection backed by a managed credential (referenced by id),
for books whose runtime supports remote secrets. Carries no inline
authentication values.
 */
export const addWorkspaceBookConnectionWithRemoteSecret = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  libraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/with-remote-secret`,
    libraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody,
    options,
  );
};

export const getAddWorkspaceBookConnectionWithRemoteSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      data: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    data: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
  },
  TContext
> => {
  const mutationKey = ['addWorkspaceBookConnectionWithRemoteSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      data: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
    }
  > = props => {
    const { organizationId, workspaceId, bookName, bookVersion, data } =
      props ?? {};

    return addWorkspaceBookConnectionWithRemoteSecret(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddWorkspaceBookConnectionWithRemoteSecretMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>
  >;
export type AddWorkspaceBookConnectionWithRemoteSecretMutationBody =
  LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
export type AddWorkspaceBookConnectionWithRemoteSecretMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Adds a book connection backed by a managed credential (referenced by id),
for books whose runtime supports remote secrets. Carries no inline
authentication values.
 */
export const useAddWorkspaceBookConnectionWithRemoteSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        data: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionWithRemoteSecret>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    data: LibraryServiceAddWorkspaceBookConnectionWithRemoteSecretBody;
  },
  TContext
> => {
  const mutationOptions =
    getAddWorkspaceBookConnectionWithRemoteSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint updates a book connection in the library.
 * @summary Updates a book connection in the library.
 */
export const updateWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceUpdateWorkspaceBookConnectionBody: LibraryServiceUpdateWorkspaceBookConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}`,
    libraryServiceUpdateWorkspaceBookConnectionBody,
    options,
  );
};

export const getUpdateWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBookConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['updateWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspaceBookConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return updateWorkspaceBookConnection(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkspaceBookConnection>>
>;
export type UpdateWorkspaceBookConnectionMutationBody =
  LibraryServiceUpdateWorkspaceBookConnectionBody;
export type UpdateWorkspaceBookConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a book connection in the library.
 */
export const useUpdateWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWorkspaceBookConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Adds a new agent trigger instance to a book connection.
An agent trigger fires a single rain agent (identified by agent_id) with the
configured literal prompt when the trigger condition is met.
 */
export const addWorkspaceBookConnectionAgentTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2AddWorkspaceBookConnectionAgentTriggerInstanceResponse>
> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/agent-triggers`,
    libraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody,
    options,
  );
};

export const getAddWorkspaceBookConnectionAgentTriggerInstanceMutationOptions =
  <TError = AxiosError<RpcStatus>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
    },
    TContext
  > => {
    const mutationKey = ['addWorkspaceBookConnectionAgentTriggerInstance'];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>
      >,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
      }
    > = props => {
      const {
        organizationId,
        workspaceId,
        bookName,
        bookVersion,
        connectionId,
        data,
      } = props ?? {};

      return addWorkspaceBookConnectionAgentTriggerInstance(
        organizationId,
        workspaceId,
        bookName,
        bookVersion,
        connectionId,
        data,
        axiosOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddWorkspaceBookConnectionAgentTriggerInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>>
  >;
export type AddWorkspaceBookConnectionAgentTriggerInstanceMutationBody =
  LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
export type AddWorkspaceBookConnectionAgentTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Adds a new agent trigger instance to a book connection.
An agent trigger fires a single rain agent (identified by agent_id) with the
configured literal prompt when the trigger condition is met.
 */
export const useAddWorkspaceBookConnectionAgentTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionAgentTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceAddWorkspaceBookConnectionAgentTriggerInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getAddWorkspaceBookConnectionAgentTriggerInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Unlike UpgradeWorkspaceBookConnection, this endpoint does not mutate the
source connection. It creates a brand-new BookConnection (with a fresh
connection_id) at new_book_version, carrying over the source connection's
credentials and configuration so the user does not have to re-enter them.
Automations attached to the source connection are not migrated; the caller
decides which automations (if any) to re-point at the new connection.

new_book_version must differ from book_version.
 * @summary Copy a book connection and upgrade the copy to a new version.
 */
export const copyAndUpgradeWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceCopyAndUpgradeWorkspaceBookConnectionBody: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/copy-and-upgrade`,
    libraryServiceCopyAndUpgradeWorkspaceBookConnectionBody,
    options,
  );
};

export const getCopyAndUpgradeWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['copyAndUpgradeWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return copyAndUpgradeWorkspaceBookConnection(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyAndUpgradeWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>
>;
export type CopyAndUpgradeWorkspaceBookConnectionMutationBody =
  LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
export type CopyAndUpgradeWorkspaceBookConnectionMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Copy a book connection and upgrade the copy to a new version.
 */
export const useCopyAndUpgradeWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof copyAndUpgradeWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceCopyAndUpgradeWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationOptions =
    getCopyAndUpgradeWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Polls are long-running background tasks that continuously monitor
external systems for changes or new data. This endpoint:
- Creates a new poll instance with a unique identifier
- Starts the polling loop in the background
- Returns the created poll instance

The poll instance is scoped to a workspace book connection, which
provides the authentication credentials for accessing external systems.
Configuration parameters can be provided to customize polling behavior.
 * @summary Adds a poll instance for a workspace book connection.
 */
export const addWorkspaceBookConnectionPollInstance = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceAddWorkspaceBookConnectionPollInstanceBody: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2AddWorkspaceBookConnectionPollInstanceResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/polls`,
    libraryServiceAddWorkspaceBookConnectionPollInstanceBody,
    options,
  );
};

export const getAddWorkspaceBookConnectionPollInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
  },
  TContext
> => {
  const mutationKey = ['addWorkspaceBookConnectionPollInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return addWorkspaceBookConnectionPollInstance(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddWorkspaceBookConnectionPollInstanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>
>;
export type AddWorkspaceBookConnectionPollInstanceMutationBody =
  LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
export type AddWorkspaceBookConnectionPollInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Adds a poll instance for a workspace book connection.
 */
export const useAddWorkspaceBookConnectionPollInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceAddWorkspaceBookConnectionPollInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getAddWorkspaceBookConnectionPollInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Adds a new trigger instance to a book connection
 */
export const addWorkspaceBookConnectionTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceAddWorkspaceBookConnectionTriggerInstanceBody: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2AddWorkspaceBookConnectionTriggerInstanceResponse>
> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/triggers`,
    libraryServiceAddWorkspaceBookConnectionTriggerInstanceBody,
    options,
  );
};

export const getAddWorkspaceBookConnectionTriggerInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
  },
  TContext
> => {
  const mutationKey = ['addWorkspaceBookConnectionTriggerInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return addWorkspaceBookConnectionTriggerInstance(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddWorkspaceBookConnectionTriggerInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>
  >;
export type AddWorkspaceBookConnectionTriggerInstanceMutationBody =
  LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
export type AddWorkspaceBookConnectionTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Adds a new trigger instance to a book connection
 */
export const useAddWorkspaceBookConnectionTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceAddWorkspaceBookConnectionTriggerInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getAddWorkspaceBookConnectionTriggerInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint upgrades a book connection to a new version.
 * @summary Upgrade a book connection to a new version.
 */
export const upgradeWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceUpgradeWorkspaceBookConnectionBody: LibraryServiceUpgradeWorkspaceBookConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/upgrade`,
    libraryServiceUpgradeWorkspaceBookConnectionBody,
    options,
  );
};

export const getUpgradeWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpgradeWorkspaceBookConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpgradeWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['upgradeWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpgradeWorkspaceBookConnectionBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return upgradeWorkspaceBookConnection(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>
>;
export type UpgradeWorkspaceBookConnectionMutationBody =
  LibraryServiceUpgradeWorkspaceBookConnectionBody;
export type UpgradeWorkspaceBookConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Upgrade a book connection to a new version.
 */
export const useUpgradeWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpgradeWorkspaceBookConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpgradeWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpgradeWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Upgrade a connection onto a credential-capable book version, migrating its
credential into the managed store. The runtime mints the managed credential
from the connection's existing (legacy) secret and attaches it.
 */
export const upgradeWorkspaceBookConnectionWithRemoteSecret = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/upgrade-with-remote-secret`,
    libraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody,
    options,
  );
};

export const getUpgradeWorkspaceBookConnectionWithRemoteSecretMutationOptions =
  <TError = AxiosError<RpcStatus>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
    },
    TContext
  > => {
    const mutationKey = ['upgradeWorkspaceBookConnectionWithRemoteSecret'];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>
      >,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
      }
    > = props => {
      const {
        organizationId,
        workspaceId,
        bookName,
        bookVersion,
        connectionId,
        data,
      } = props ?? {};

      return upgradeWorkspaceBookConnectionWithRemoteSecret(
        organizationId,
        workspaceId,
        bookName,
        bookVersion,
        connectionId,
        data,
        axiosOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpgradeWorkspaceBookConnectionWithRemoteSecretMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>>
  >;
export type UpgradeWorkspaceBookConnectionWithRemoteSecretMutationBody =
  LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
export type UpgradeWorkspaceBookConnectionWithRemoteSecretMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Upgrade a connection onto a credential-capable book version, migrating its
credential into the managed store. The runtime mints the managed credential
from the connection's existing (legacy) secret and attaches it.
 */
export const useUpgradeWorkspaceBookConnectionWithRemoteSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeWorkspaceBookConnectionWithRemoteSecret>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpgradeWorkspaceBookConnectionWithRemoteSecretBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpgradeWorkspaceBookConnectionWithRemoteSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a credential-backed book connection (re-point the managed credential
and/or update config/labels). Carries no inline authentication values.
 */
export const updateWorkspaceBookConnectionWithRemoteSecret = (
  organizationId: string,
  workspaceId: string,
  bookName: string,
  bookVersion: string,
  connectionId: string,
  libraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${bookName}/${bookVersion}/connections/${connectionId}/with-remote-secret`,
    libraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody,
    options,
  );
};

export const getUpdateWorkspaceBookConnectionWithRemoteSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
  },
  TContext
> => {
  const mutationKey = ['updateWorkspaceBookConnectionWithRemoteSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>,
    {
      organizationId: string;
      workspaceId: string;
      bookName: string;
      bookVersion: string;
      connectionId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
    } = props ?? {};

    return updateWorkspaceBookConnectionWithRemoteSecret(
      organizationId,
      workspaceId,
      bookName,
      bookVersion,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceBookConnectionWithRemoteSecretMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>
  >;
export type UpdateWorkspaceBookConnectionWithRemoteSecretMutationBody =
  LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
export type UpdateWorkspaceBookConnectionWithRemoteSecretMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Updates a credential-backed book connection (re-point the managed credential
and/or update config/labels). Carries no inline authentication values.
 */
export const useUpdateWorkspaceBookConnectionWithRemoteSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        bookName: string;
        bookVersion: string;
        connectionId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionWithRemoteSecret>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    bookName: string;
    bookVersion: string;
    connectionId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionWithRemoteSecretBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkspaceBookConnectionWithRemoteSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns a list of all version strings available for the
specified book name in the workspace context (global + workspace-private).
 * @summary Retrieves all available versions for a specific book visible in a workspace.
 */
export const retrieveWorkspaceBookVersions = (
  organizationId: string,
  workspaceId: string,
  name: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookVersionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/versions`,
    options,
  );
};

export const getRetrieveWorkspaceBookVersionsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  name?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/versions`,
  ] as const;
};

export const getRetrieveWorkspaceBookVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookVersionsQueryKey(organizationId, workspaceId, name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>
  > = ({ signal }) =>
    retrieveWorkspaceBookVersions(organizationId, workspaceId, name, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && name),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>
>;
export type RetrieveWorkspaceBookVersionsQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookVersions<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookVersions<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookVersions<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available versions for a specific book visible in a workspace.
 */

export function useRetrieveWorkspaceBookVersions<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookVersionsQueryOptions(
    organizationId,
    workspaceId,
    name,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint provides comprehensive metadata about a particular book in
the workspace context, including books that are private to the workspace
and not visible in the global library.
 * @summary Retrieves detailed information about a specific book version in a workspace.
 */
export const retrieveWorkspaceBook = (
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBookResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}`,
    options,
  );
};

export const getRetrieveWorkspaceBookQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  name?: string,
  version?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}`,
  ] as const;
};

export const getRetrieveWorkspaceBookQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookQueryKey(
      organizationId,
      workspaceId,
      name,
      version,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBook>>
  > = ({ signal }) =>
    retrieveWorkspaceBook(organizationId, workspaceId, name, version, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBook>>
>;
export type RetrieveWorkspaceBookQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBook<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBook>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBook<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBook>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBook<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves detailed information about a specific book version in a workspace.
 */

export function useRetrieveWorkspaceBook<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBook>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookQueryOptions(
    organizationId,
    workspaceId,
    name,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of concept descriptors defined by the
specified book in the workspace, which can be referenced by procedures as inputs or outputs.
 * @summary Retrieves all available concepts for the specified book version in a workspace.
 */
export const retrieveWorkspaceBookConcepts = (
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookConceptsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}/concepts`,
    options,
  );
};

export const getRetrieveWorkspaceBookConceptsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  name?: string,
  version?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}/concepts`,
  ] as const;
};

export const getRetrieveWorkspaceBookConceptsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConceptsQueryKey(
      organizationId,
      workspaceId,
      name,
      version,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConcepts(organizationId, workspaceId, name, version, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConceptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>
>;
export type RetrieveWorkspaceBookConceptsQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available concepts for the specified book version in a workspace.
 */

export function useRetrieveWorkspaceBookConcepts<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConcepts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookConceptsQueryOptions(
    organizationId,
    workspaceId,
    name,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a list of all procedures (functions/operations) that
can be invoked on the specified book in the workspace, along with their signatures,
input/output parameters, and metadata such as descriptions and examples.
 * @summary Retrieves all available procedures for the specified book version in a workspace.
 */
export const retrieveWorkspaceBookProcedures = (
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBookProceduresResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}/procedures`,
    options,
  );
};

export const getRetrieveWorkspaceBookProceduresQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  name?: string,
  version?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books/${name}/${version}/procedures`,
  ] as const;
};

export const getRetrieveWorkspaceBookProceduresQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookProceduresQueryKey(
      organizationId,
      workspaceId,
      name,
      version,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>
  > = ({ signal }) =>
    retrieveWorkspaceBookProcedures(
      organizationId,
      workspaceId,
      name,
      version,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && name && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookProceduresQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>
>;
export type RetrieveWorkspaceBookProceduresQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available procedures for the specified book version in a workspace.
 */

export function useRetrieveWorkspaceBookProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  name: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookProceduresQueryOptions(
    organizationId,
    workspaceId,
    name,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns metadata for the latest version of each book that is
currently available in the runtime for the specified workspace. The result is
the union of global library books and any workspace-private books.
 * @summary Retrieves the latest version of every book available in the workspace.
 */
export const retrieveLatestWorkspaceBooks = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveLatestWorkspaceBooksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBooksResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books:latest`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveLatestWorkspaceBooksQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveLatestWorkspaceBooksParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books:latest`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveLatestWorkspaceBooksQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveLatestWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveLatestWorkspaceBooksQueryKey(
      organizationId,
      workspaceId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>
  > = ({ signal }) =>
    retrieveLatestWorkspaceBooks(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveLatestWorkspaceBooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>
>;
export type RetrieveLatestWorkspaceBooksQueryError = AxiosError<RpcStatus>;

export function useRetrieveLatestWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveLatestWorkspaceBooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveLatestWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveLatestWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
          TError,
          Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveLatestWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveLatestWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves the latest version of every book available in the workspace.
 */

export function useRetrieveLatestWorkspaceBooks<
  TData = Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveLatestWorkspaceBooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveLatestWorkspaceBooks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveLatestWorkspaceBooksQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns ranked books that best match the provided query.
Each result includes a full book descriptor and a relevance score.
 * @summary Searches books across the library in a workspace.
 */
export const searchWorkspaceBooks = (
  organizationId: string,
  workspaceId: string,
  libraryServiceSearchWorkspaceBooksBody: LibraryServiceSearchWorkspaceBooksBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchBooksResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/books:search`,
    libraryServiceSearchWorkspaceBooksBody,
    options,
  );
};

export const getSearchWorkspaceBooksMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchWorkspaceBooks>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBooksBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchWorkspaceBooks>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBooksBody;
  },
  TContext
> => {
  const mutationKey = ['searchWorkspaceBooks'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchWorkspaceBooks>>,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBooksBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return searchWorkspaceBooks(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchWorkspaceBooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchWorkspaceBooks>>
>;
export type SearchWorkspaceBooksMutationBody =
  LibraryServiceSearchWorkspaceBooksBody;
export type SearchWorkspaceBooksMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches books across the library in a workspace.
 */
export const useSearchWorkspaceBooks = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchWorkspaceBooks>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: LibraryServiceSearchWorkspaceBooksBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchWorkspaceBooks>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBooksBody;
  },
  TContext
> => {
  const mutationOptions = getSearchWorkspaceBooksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns ranked concepts that best match the provided query.
Each result includes the owning book name, version, a full concept descriptor, and a relevance score.
 * @summary Searches concepts across the library in a workspace.
 */
export const searchWorkspaceBookConcepts = (
  organizationId: string,
  workspaceId: string,
  libraryServiceSearchWorkspaceBookConceptsBody: LibraryServiceSearchWorkspaceBookConceptsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchBookConceptsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/concepts:search`,
    libraryServiceSearchWorkspaceBookConceptsBody,
    options,
  );
};

export const getSearchWorkspaceBookConceptsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBookConceptsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBookConceptsBody;
  },
  TContext
> => {
  const mutationKey = ['searchWorkspaceBookConcepts'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBookConceptsBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return searchWorkspaceBookConcepts(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchWorkspaceBookConceptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>
>;
export type SearchWorkspaceBookConceptsMutationBody =
  LibraryServiceSearchWorkspaceBookConceptsBody;
export type SearchWorkspaceBookConceptsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches concepts across the library in a workspace.
 */
export const useSearchWorkspaceBookConcepts = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: LibraryServiceSearchWorkspaceBookConceptsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchWorkspaceBookConcepts>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBookConceptsBody;
  },
  TContext
> => {
  const mutationOptions =
    getSearchWorkspaceBookConceptsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retrieve all connections of all book versions.
 */
export const retrieveAllWorkspaceBookConnections = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBooksConnectionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveAllWorkspaceBookConnectionsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveAllWorkspaceBookConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveAllWorkspaceBookConnectionsQueryKey(
      organizationId,
      workspaceId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>
  > = ({ signal }) =>
    retrieveAllWorkspaceBookConnections(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveAllWorkspaceBookConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>
>;
export type RetrieveAllWorkspaceBookConnectionsQueryError =
  AxiosError<RpcStatus>;

export function useRetrieveAllWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveAllWorkspaceBookConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
          TError,
          Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveAllWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
          TError,
          Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveAllWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve all connections of all book versions.
 */

export function useRetrieveAllWorkspaceBookConnections<
  TData = Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveAllWorkspaceBookConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveAllWorkspaceBookConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveAllWorkspaceBookConnectionsQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns a specific book connection.
 * @summary Retrieve a specific book connection by id.
 */
export const retrieveWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBookConnectionResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}`,
    options,
  );
};

export const getRetrieveWorkspaceBookConnectionQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  connectionId?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}`,
  ] as const;
};

export const getRetrieveWorkspaceBookConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConnectionQueryKey(
      organizationId,
      workspaceId,
      connectionId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConnection(organizationId, workspaceId, connectionId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && connectionId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>
>;
export type RetrieveWorkspaceBookConnectionQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConnection<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnection<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnection<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve a specific book connection by id.
 */

export function useRetrieveWorkspaceBookConnection<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnection>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookConnectionQueryOptions(
    organizationId,
    workspaceId,
    connectionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Removes an agent trigger instance from a book connection.
 */
export const removeWorkspaceBookConnectionAgentTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  triggerInstanceId: string,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2RemoveWorkspaceBookConnectionAgentTriggerInstanceResponse>
> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/agent-triggers/${triggerInstanceId}`,
    options,
  );
};

export const getRemoveWorkspaceBookConnectionAgentTriggerInstanceMutationOptions =
  <TError = AxiosError<RpcStatus>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>
    >,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
    },
    TContext
  > => {
    const mutationKey = ['removeWorkspaceBookConnectionAgentTriggerInstance'];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>
      >,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
      }
    > = props => {
      const { organizationId, workspaceId, connectionId, triggerInstanceId } =
        props ?? {};

      return removeWorkspaceBookConnectionAgentTriggerInstance(
        organizationId,
        workspaceId,
        connectionId,
        triggerInstanceId,
        axiosOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveWorkspaceBookConnectionAgentTriggerInstanceMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>
    >
  >;

export type RemoveWorkspaceBookConnectionAgentTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Removes an agent trigger instance from a book connection.
 */
export const useRemoveWorkspaceBookConnectionAgentTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceBookConnectionAgentTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveWorkspaceBookConnectionAgentTriggerInstanceMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing agent trigger instance.
Uses PUT semantics - all fields are required and will replace the existing values.
 */
export const updateWorkspaceBookConnectionAgentTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  triggerInstanceId: string,
  libraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2UpdateWorkspaceBookConnectionAgentTriggerInstanceResponse>
> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/agent-triggers/${triggerInstanceId}`,
    libraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody,
    options,
  );
};

export const getUpdateWorkspaceBookConnectionAgentTriggerInstanceMutationOptions =
  <TError = AxiosError<RpcStatus>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>
    >,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
    },
    TContext
  > => {
    const mutationKey = ['updateWorkspaceBookConnectionAgentTriggerInstance'];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>
      >,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
      }
    > = props => {
      const {
        organizationId,
        workspaceId,
        connectionId,
        triggerInstanceId,
        data,
      } = props ?? {};

      return updateWorkspaceBookConnectionAgentTriggerInstance(
        organizationId,
        workspaceId,
        connectionId,
        triggerInstanceId,
        data,
        axiosOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateWorkspaceBookConnectionAgentTriggerInstanceMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>
    >
  >;
export type UpdateWorkspaceBookConnectionAgentTriggerInstanceMutationBody =
  LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
export type UpdateWorkspaceBookConnectionAgentTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Updates an existing agent trigger instance.
Uses PUT semantics - all fields are required and will replace the existing values.
 */
export const useUpdateWorkspaceBookConnectionAgentTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>
      >,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionAgentTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionAgentTriggerInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkspaceBookConnectionAgentTriggerInstanceMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint generates a new authrization url for an existing book connection.
 * @summary Refresh authorization for a book connection.
 */
export const authorizeWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/authorize`,
    undefined,
    options,
  );
};

export const getAuthorizeWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>,
    TError,
    { organizationId: string; workspaceId: string; connectionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>,
  TError,
  { organizationId: string; workspaceId: string; connectionId: string },
  TContext
> => {
  const mutationKey = ['authorizeWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>,
    { organizationId: string; workspaceId: string; connectionId: string }
  > = props => {
    const { organizationId, workspaceId, connectionId } = props ?? {};

    return authorizeWorkspaceBookConnection(
      organizationId,
      workspaceId,
      connectionId,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthorizeWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>
>;

export type AuthorizeWorkspaceBookConnectionMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Refresh authorization for a book connection.
 */
export const useAuthorizeWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>,
      TError,
      { organizationId: string; workspaceId: string; connectionId: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authorizeWorkspaceBookConnection>>,
  TError,
  { organizationId: string; workspaceId: string; connectionId: string },
  TContext
> => {
  const mutationOptions =
    getAuthorizeWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint allows books to discover and register new procedures
at runtime by connecting to external APIs, databases, or services.
The discovered procedures become available for invocation.

Supports:
- Specification of what entities to discover
- Dynamic procedure registration

Note: This will override any existing discoverables, and sending an empty list will remove all discoverables.
 * @summary Sets the list of things to discover for a book connection.
 */
export const setDiscovered = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  libraryServiceSetDiscoveredBody: LibraryServiceSetDiscoveredBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2DiscoverWorkspaceBookConnectionProceduresResponse>
> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/discover`,
    libraryServiceSetDiscoveredBody,
    options,
  );
};

export const getSetDiscoveredMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDiscovered>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceSetDiscoveredBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDiscovered>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceSetDiscoveredBody;
  },
  TContext
> => {
  const mutationKey = ['setDiscovered'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDiscovered>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceSetDiscoveredBody;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, data } = props ?? {};

    return setDiscovered(
      organizationId,
      workspaceId,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDiscoveredMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDiscovered>>
>;
export type SetDiscoveredMutationBody = LibraryServiceSetDiscoveredBody;
export type SetDiscoveredMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sets the list of things to discover for a book connection.
 */
export const useSetDiscovered = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setDiscovered>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        data: LibraryServiceSetDiscoveredBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setDiscovered>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceSetDiscoveredBody;
  },
  TContext
> => {
  const mutationOptions = getSetDiscoveredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns a list of entities (like database tables, API endpoints,
file systems, etc.) that can be discovered from a specific book connection
and potentially converted into executable procedures.
 * @summary Retrieves discoverable entities from a workspace book connection.
 */
export const retrieveWorkspaceBookConnectionDiscoverables = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveDiscoverablesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/discoverables`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceBookConnectionDiscoverablesQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  connectionId?: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/discoverables`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceBookConnectionDiscoverablesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConnectionDiscoverablesQueryKey(
      organizationId,
      workspaceId,
      connectionId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConnectionDiscoverables(
      organizationId,
      workspaceId,
      connectionId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && connectionId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConnectionDiscoverablesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>>
  >;
export type RetrieveWorkspaceBookConnectionDiscoverablesQueryError =
  AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConnectionDiscoverables<
  TData = Awaited<
    ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params: undefined | RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
          >,
          TError,
          Awaited<
            ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionDiscoverables<
  TData = Awaited<
    ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
          >,
          TError,
          Awaited<
            ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionDiscoverables<
  TData = Awaited<
    ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves discoverable entities from a workspace book connection.
 */

export function useRetrieveWorkspaceBookConnectionDiscoverables<
  TData = Awaited<
    ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionDiscoverablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof retrieveWorkspaceBookConnectionDiscoverables>
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getRetrieveWorkspaceBookConnectionDiscoverablesQueryOptions(
      organizationId,
      workspaceId,
      connectionId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint gracefully terminates a poll that was previously
added via AddWorkspaceBookConnectionPollInstance. The poll will stop
monitoring the external system and clean up any resources.
 * @summary Removes a running poll instance.
 */
export const removeWorkspaceBookConnectionPollInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  pollInstanceId: string,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2RemoveWorkspaceBookConnectionPollInstanceResponse>
> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/polls/${pollInstanceId}`,
    options,
  );
};

export const getRemoveWorkspaceBookConnectionPollInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      pollInstanceId: string;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    pollInstanceId: string;
  },
  TContext
> => {
  const mutationKey = ['removeWorkspaceBookConnectionPollInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      pollInstanceId: string;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, pollInstanceId } =
      props ?? {};

    return removeWorkspaceBookConnectionPollInstance(
      organizationId,
      workspaceId,
      connectionId,
      pollInstanceId,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveWorkspaceBookConnectionPollInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>
  >;

export type RemoveWorkspaceBookConnectionPollInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Removes a running poll instance.
 */
export const useRemoveWorkspaceBookConnectionPollInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        pollInstanceId: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    pollInstanceId: string;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveWorkspaceBookConnectionPollInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing poll instance's name, configuration, filter expression, and poll interval.
Uses PUT semantics - name and configuration replace the existing values.
poll_interval_minutes is optional; when omitted, the existing interval is preserved.
 */
export const updateWorkspaceBookConnectionPollInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  pollInstanceId: string,
  libraryServiceUpdateWorkspaceBookConnectionPollInstanceBody: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2UpdateWorkspaceBookConnectionPollInstanceResponse>
> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/polls/${pollInstanceId}`,
    libraryServiceUpdateWorkspaceBookConnectionPollInstanceBody,
    options,
  );
};

export const getUpdateWorkspaceBookConnectionPollInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      pollInstanceId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    pollInstanceId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
  },
  TContext
> => {
  const mutationKey = ['updateWorkspaceBookConnectionPollInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      pollInstanceId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, pollInstanceId, data } =
      props ?? {};

    return updateWorkspaceBookConnectionPollInstance(
      organizationId,
      workspaceId,
      connectionId,
      pollInstanceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceBookConnectionPollInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>
  >;
export type UpdateWorkspaceBookConnectionPollInstanceMutationBody =
  LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
export type UpdateWorkspaceBookConnectionPollInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Updates an existing poll instance's name, configuration, filter expression, and poll interval.
Uses PUT semantics - name and configuration replace the existing values.
poll_interval_minutes is optional; when omitted, the existing interval is preserved.
 */
export const useUpdateWorkspaceBookConnectionPollInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        pollInstanceId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    pollInstanceId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionPollInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkspaceBookConnectionPollInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns a list of all procedures (functions/operations) that
can be invoked on the specified book connection in the workspace, along with their signatures,
input/output parameters, and metadata such as descriptions and examples.
 * @summary Retrieves all available procedures for a book connection in a workspace (static and discovered).
 */
export const retrieveWorkspaceBookConnectionProcedures = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveBookProceduresResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/procedures`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceBookConnectionProceduresQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  connectionId?: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/procedures`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceBookConnectionProceduresQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConnectionProceduresQueryKey(
      organizationId,
      workspaceId,
      connectionId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConnectionProcedures(
      organizationId,
      workspaceId,
      connectionId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && connectionId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConnectionProceduresQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>
>;
export type RetrieveWorkspaceBookConnectionProceduresQueryError =
  AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConnectionProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params: undefined | RetrieveWorkspaceBookConnectionProceduresParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available procedures for a book connection in a workspace (static and discovered).
 */

export function useRetrieveWorkspaceBookConnectionProcedures<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  params?: RetrieveWorkspaceBookConnectionProceduresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionProcedures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookConnectionProceduresQueryOptions(
    organizationId,
    workspaceId,
    connectionId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint returns ranked procedures that best match the provided query.
Each result includes the owning book name and version, a full procedure descriptor,
and a relevance score.
 * @summary Searches procedures across all available books in a workspace (static and discovered).
 */
export const searchWorkspaceBookConnectionProcedures = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  libraryServiceSearchWorkspaceBookConnectionProceduresBody: LibraryServiceSearchWorkspaceBookConnectionProceduresBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchWorkspaceBookProceduresResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/procedures:search`,
    libraryServiceSearchWorkspaceBookConnectionProceduresBody,
    options,
  );
};

export const getSearchWorkspaceBookConnectionProceduresMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
  },
  TContext
> => {
  const mutationKey = ['searchWorkspaceBookConnectionProcedures'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, data } = props ?? {};

    return searchWorkspaceBookConnectionProcedures(
      organizationId,
      workspaceId,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchWorkspaceBookConnectionProceduresMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>
>;
export type SearchWorkspaceBookConnectionProceduresMutationBody =
  LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
export type SearchWorkspaceBookConnectionProceduresMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Searches procedures across all available books in a workspace (static and discovered).
 */
export const useSearchWorkspaceBookConnectionProcedures = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        data: LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchWorkspaceBookConnectionProcedures>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceSearchWorkspaceBookConnectionProceduresBody;
  },
  TContext
> => {
  const mutationOptions =
    getSearchWorkspaceBookConnectionProceduresMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint adds a label to the book connection to associate it with a remote connection.
 * @summary Associate a remote connection with a book connection.
 */
export const associateRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  libraryServiceAssociateRemoteConnectionBody: LibraryServiceAssociateRemoteConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/remote-connection`,
    libraryServiceAssociateRemoteConnectionBody,
    options,
  );
};

export const getAssociateRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof associateRemoteConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceAssociateRemoteConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof associateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceAssociateRemoteConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['associateRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof associateRemoteConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceAssociateRemoteConnectionBody;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, data } = props ?? {};

    return associateRemoteConnection(
      organizationId,
      workspaceId,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AssociateRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof associateRemoteConnection>>
>;
export type AssociateRemoteConnectionMutationBody =
  LibraryServiceAssociateRemoteConnectionBody;
export type AssociateRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Associate a remote connection with a book connection.
 */
export const useAssociateRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof associateRemoteConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        data: LibraryServiceAssociateRemoteConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof associateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceAssociateRemoteConnectionBody;
  },
  TContext
> => {
  const mutationOptions = getAssociateRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint removes the remote connection association label from the book connection.
 * @summary Disassociate a remote connection from a book connection.
 */
export const disassociateRemoteConnection = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  remoteConnectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/remote-connection/${remoteConnectionId}`,
    options,
  );
};

export const getDisassociateRemoteConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disassociateRemoteConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      remoteConnectionId: string;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disassociateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    remoteConnectionId: string;
  },
  TContext
> => {
  const mutationKey = ['disassociateRemoteConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disassociateRemoteConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      remoteConnectionId: string;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, remoteConnectionId } =
      props ?? {};

    return disassociateRemoteConnection(
      organizationId,
      workspaceId,
      connectionId,
      remoteConnectionId,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DisassociateRemoteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof disassociateRemoteConnection>>
>;

export type DisassociateRemoteConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Disassociate a remote connection from a book connection.
 */
export const useDisassociateRemoteConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disassociateRemoteConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        remoteConnectionId: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof disassociateRemoteConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    remoteConnectionId: string;
  },
  TContext
> => {
  const mutationOptions =
    getDisassociateRemoteConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Removes a trigger instance from a book connection
 */
export const removeWorkspaceBookConnectionTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  triggerInstanceId: string,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2RemoveWorkspaceBookConnectionTriggerInstanceResponse>
> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/triggers/${triggerInstanceId}`,
    options,
  );
};

export const getRemoveWorkspaceBookConnectionTriggerInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
  },
  TContext
> => {
  const mutationKey = ['removeWorkspaceBookConnectionTriggerInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, triggerInstanceId } =
      props ?? {};

    return removeWorkspaceBookConnectionTriggerInstance(
      organizationId,
      workspaceId,
      connectionId,
      triggerInstanceId,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveWorkspaceBookConnectionTriggerInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>
  >;

export type RemoveWorkspaceBookConnectionTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Removes a trigger instance from a book connection
 */
export const useRemoveWorkspaceBookConnectionTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveWorkspaceBookConnectionTriggerInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing trigger instance's name, configuration, and filter expression.
Uses PUT semantics - all fields are required and will replace the existing values.
 */
export const updateWorkspaceBookConnectionTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  triggerInstanceId: string,
  libraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<V2UpdateWorkspaceBookConnectionTriggerInstanceResponse>
> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/triggers/${triggerInstanceId}`,
    libraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody,
    options,
  );
};

export const getUpdateWorkspaceBookConnectionTriggerInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
  },
  TContext
> => {
  const mutationKey = ['updateWorkspaceBookConnectionTriggerInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      triggerInstanceId: string;
      data: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
    }
  > = props => {
    const {
      organizationId,
      workspaceId,
      connectionId,
      triggerInstanceId,
      data,
    } = props ?? {};

    return updateWorkspaceBookConnectionTriggerInstance(
      organizationId,
      workspaceId,
      connectionId,
      triggerInstanceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceBookConnectionTriggerInstanceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>
  >;
export type UpdateWorkspaceBookConnectionTriggerInstanceMutationBody =
  LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
export type UpdateWorkspaceBookConnectionTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Updates an existing trigger instance's name, configuration, and filter expression.
Uses PUT semantics - all fields are required and will replace the existing values.
 */
export const useUpdateWorkspaceBookConnectionTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        triggerInstanceId: string;
        data: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspaceBookConnectionTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    triggerInstanceId: string;
    data: LibraryServiceUpdateWorkspaceBookConnectionTriggerInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkspaceBookConnectionTriggerInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns information about the user (email, username and other extra attributes) from
 a book that has already been connected.
 * @summary Retrieves information about the user from the book's connection (only auth code flow connections).
 */
export const retrieveWorkspaceBookConnectionUserInfo = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveUserInfoResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/user-info`,
    options,
  );
};

export const getRetrieveWorkspaceBookConnectionUserInfoQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  connectionId?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}/user-info`,
  ] as const;
};

export const getRetrieveWorkspaceBookConnectionUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceBookConnectionUserInfoQueryKey(
      organizationId,
      workspaceId,
      connectionId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>
  > = ({ signal }) =>
    retrieveWorkspaceBookConnectionUserInfo(
      organizationId,
      workspaceId,
      connectionId,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && connectionId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceBookConnectionUserInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>
>;
export type RetrieveWorkspaceBookConnectionUserInfoQueryError =
  AxiosError<RpcStatus>;

export function useRetrieveWorkspaceBookConnectionUserInfo<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionUserInfo<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceBookConnectionUserInfo<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves information about the user from the book's connection (only auth code flow connections).
 */

export function useRetrieveWorkspaceBookConnectionUserInfo<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionUserInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceBookConnectionUserInfoQueryOptions(
    organizationId,
    workspaceId,
    connectionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reactivate a book connection that was scaled to zero due to inactivity.
Moves the connection out of the Inactive state so the controller scales its
pod back up. Internal services call this over gRPC; the HTTP route is
provided so it can also be exposed to users from the UI if desired.
 */
export const reactivateWorkspaceBookConnection = (
  organizationId: string,
  workspaceId: string,
  connectionId: string,
  libraryServiceReactivateWorkspaceBookConnectionBody: LibraryServiceReactivateWorkspaceBookConnectionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2BookConnectionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections/${connectionId}:reactivate`,
    libraryServiceReactivateWorkspaceBookConnectionBody,
    options,
  );
};

export const getReactivateWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceReactivateWorkspaceBookConnectionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceReactivateWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationKey = ['reactivateWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>,
    {
      organizationId: string;
      workspaceId: string;
      connectionId: string;
      data: LibraryServiceReactivateWorkspaceBookConnectionBody;
    }
  > = props => {
    const { organizationId, workspaceId, connectionId, data } = props ?? {};

    return reactivateWorkspaceBookConnection(
      organizationId,
      workspaceId,
      connectionId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReactivateWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>
>;
export type ReactivateWorkspaceBookConnectionMutationBody =
  LibraryServiceReactivateWorkspaceBookConnectionBody;
export type ReactivateWorkspaceBookConnectionMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Reactivate a book connection that was scaled to zero due to inactivity.
Moves the connection out of the Inactive state so the controller scales its
pod back up. Internal services call this over gRPC; the HTTP route is
provided so it can also be exposed to users from the UI if desired.
 */
export const useReactivateWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        connectionId: string;
        data: LibraryServiceReactivateWorkspaceBookConnectionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reactivateWorkspaceBookConnection>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    connectionId: string;
    data: LibraryServiceReactivateWorkspaceBookConnectionBody;
  },
  TContext
> => {
  const mutationOptions =
    getReactivateWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint is designed to avoid LISTing all connections in a workspace
when the caller already knows the specific connection IDs it needs.
 * @summary Retrieve multiple book connections by id in one call.
 */
export const retrieveWorkspaceBookConnectionsByIds = (
  organizationId: string,
  workspaceId: string,
  libraryServiceRetrieveWorkspaceBookConnectionsByIdsBody: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveBooksConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/connections:batchGet`,
    libraryServiceRetrieveWorkspaceBookConnectionsByIdsBody,
    options,
  );
};

export const getRetrieveWorkspaceBookConnectionsByIdsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
  },
  TContext
> => {
  const mutationKey = ['retrieveWorkspaceBookConnectionsByIds'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return retrieveWorkspaceBookConnectionsByIds(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RetrieveWorkspaceBookConnectionsByIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>
>;
export type RetrieveWorkspaceBookConnectionsByIdsMutationBody =
  LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
export type RetrieveWorkspaceBookConnectionsByIdsMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Retrieve multiple book connections by id in one call.
 */
export const useRetrieveWorkspaceBookConnectionsByIds = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retrieveWorkspaceBookConnectionsByIds>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceRetrieveWorkspaceBookConnectionsByIdsBody;
  },
  TContext
> => {
  const mutationOptions =
    getRetrieveWorkspaceBookConnectionsByIdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retrieve all poll instances for a workspace
 */
export const retrieveWorkspacePollInstances = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspacePollInstancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveWorkspacePollInstancesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/polls`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspacePollInstancesQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveWorkspacePollInstancesParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/polls`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspacePollInstancesQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspacePollInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspacePollInstancesQueryKey(
      organizationId,
      workspaceId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>
  > = ({ signal }) =>
    retrieveWorkspacePollInstances(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspacePollInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>
>;
export type RetrieveWorkspacePollInstancesQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspacePollInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveWorkspacePollInstancesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspacePollInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspacePollInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspacePollInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspacePollInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve all poll instances for a workspace
 */

export function useRetrieveWorkspacePollInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspacePollInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspacePollInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspacePollInstancesQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Attach automations to a poll instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const setAutomationsForPollInstance = (
  organizationId: string,
  workspaceId: string,
  pollInstanceId: string,
  libraryServiceSetAutomationsForPollInstanceBody: LibraryServiceSetAutomationsForPollInstanceBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SetAutomationsForPollInstanceResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/polls/${pollInstanceId}/automations`,
    libraryServiceSetAutomationsForPollInstanceBody,
    options,
  );
};

export const getSetAutomationsForPollInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutomationsForPollInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      pollInstanceId: string;
      data: LibraryServiceSetAutomationsForPollInstanceBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutomationsForPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    pollInstanceId: string;
    data: LibraryServiceSetAutomationsForPollInstanceBody;
  },
  TContext
> => {
  const mutationKey = ['setAutomationsForPollInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutomationsForPollInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      pollInstanceId: string;
      data: LibraryServiceSetAutomationsForPollInstanceBody;
    }
  > = props => {
    const { organizationId, workspaceId, pollInstanceId, data } = props ?? {};

    return setAutomationsForPollInstance(
      organizationId,
      workspaceId,
      pollInstanceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutomationsForPollInstanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutomationsForPollInstance>>
>;
export type SetAutomationsForPollInstanceMutationBody =
  LibraryServiceSetAutomationsForPollInstanceBody;
export type SetAutomationsForPollInstanceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Attach automations to a poll instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const useSetAutomationsForPollInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAutomationsForPollInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        pollInstanceId: string;
        data: LibraryServiceSetAutomationsForPollInstanceBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAutomationsForPollInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    pollInstanceId: string;
    data: LibraryServiceSetAutomationsForPollInstanceBody;
  },
  TContext
> => {
  const mutationOptions =
    getSetAutomationsForPollInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns ranked procedures that best match the provided query.
Each result includes the owning book name and version, a full procedure descriptor,
and a relevance score.
 * @summary Searches procedures across all available books in a workspace (static and discovered).
 */
export const searchWorkspaceBookProcedures = (
  organizationId: string,
  workspaceId: string,
  libraryServiceSearchWorkspaceBookProceduresBody: LibraryServiceSearchWorkspaceBookProceduresBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchWorkspaceBookProceduresResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/procedures:search`,
    libraryServiceSearchWorkspaceBookProceduresBody,
    options,
  );
};

export const getSearchWorkspaceBookProceduresMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBookProceduresBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBookProceduresBody;
  },
  TContext
> => {
  const mutationKey = ['searchWorkspaceBookProcedures'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>,
    {
      organizationId: string;
      workspaceId: string;
      data: LibraryServiceSearchWorkspaceBookProceduresBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return searchWorkspaceBookProcedures(
      organizationId,
      workspaceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchWorkspaceBookProceduresMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>
>;
export type SearchWorkspaceBookProceduresMutationBody =
  LibraryServiceSearchWorkspaceBookProceduresBody;
export type SearchWorkspaceBookProceduresMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches procedures across all available books in a workspace (static and discovered).
 */
export const useSearchWorkspaceBookProcedures = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: LibraryServiceSearchWorkspaceBookProceduresBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchWorkspaceBookProcedures>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: LibraryServiceSearchWorkspaceBookProceduresBody;
  },
  TContext
> => {
  const mutationOptions =
    getSearchWorkspaceBookProceduresMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns a consolidated list of all tags used across the books
visible in the workspace context (global library + workspace-private books).
 * @summary Retrieves all available tags from books visible in a workspace.
 */
export const retrieveWorkspaceTags = (
  organizationId: string,
  workspaceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveTagsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/tags`,
    options,
  );
};

export const getRetrieveWorkspaceTagsQueryKey = (
  organizationId?: string,
  workspaceId?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/tags`,
  ] as const;
};

export const getRetrieveWorkspaceTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceTagsQueryKey(organizationId, workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceTags>>
  > = ({ signal }) =>
    retrieveWorkspaceTags(organizationId, workspaceId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceTags>>
>;
export type RetrieveWorkspaceTagsQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceTags<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceTags<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceTags<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available tags from books visible in a workspace.
 */

export function useRetrieveWorkspaceTags<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTags>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceTagsQueryOptions(
    organizationId,
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Retrieve all trigger instances for a book connection
 */
export const retrieveWorkspaceTriggerInstances = (
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RetrieveWorkspaceTriggerInstancesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/triggers`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getRetrieveWorkspaceTriggerInstancesQueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/triggers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRetrieveWorkspaceTriggerInstancesQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRetrieveWorkspaceTriggerInstancesQueryKey(
      organizationId,
      workspaceId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>
  > = ({ signal }) =>
    retrieveWorkspaceTriggerInstances(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveWorkspaceTriggerInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>
>;
export type RetrieveWorkspaceTriggerInstancesQueryError = AxiosError<RpcStatus>;

export function useRetrieveWorkspaceTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | RetrieveWorkspaceTriggerInstancesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
          TError,
          Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveWorkspaceTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve all trigger instances for a book connection
 */

export function useRetrieveWorkspaceTriggerInstances<
  TData = Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: RetrieveWorkspaceTriggerInstancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof retrieveWorkspaceTriggerInstances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveWorkspaceTriggerInstancesQueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Both POST and PUT are accepted at the same path. PUT is preferred and
matches the replace-collection semantics; the POST binding is retained
for backwards compatibility and may be removed in a future version.
 * @summary Attach automations to a trigger instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const setAutomationsForTriggerInstance2 = (
  organizationId: string,
  workspaceId: string,
  triggerInstanceId: string,
  libraryServiceSetAutomationsForTriggerInstanceBodyBody: LibraryServiceSetAutomationsForTriggerInstanceBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SetAutomationsForTriggerInstanceResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/triggers/${triggerInstanceId}/automations`,
    libraryServiceSetAutomationsForTriggerInstanceBodyBody,
    options,
  );
};

export const getSetAutomationsForTriggerInstance2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      triggerInstanceId: string;
      data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    triggerInstanceId: string;
    data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
  },
  TContext
> => {
  const mutationKey = ['setAutomationsForTriggerInstance2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>,
    {
      organizationId: string;
      workspaceId: string;
      triggerInstanceId: string;
      data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, triggerInstanceId, data } =
      props ?? {};

    return setAutomationsForTriggerInstance2(
      organizationId,
      workspaceId,
      triggerInstanceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutomationsForTriggerInstance2MutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>
>;
export type SetAutomationsForTriggerInstance2MutationBody =
  LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
export type SetAutomationsForTriggerInstance2MutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Attach automations to a trigger instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const useSetAutomationsForTriggerInstance2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        triggerInstanceId: string;
        data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    triggerInstanceId: string;
    data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
  },
  TContext
> => {
  const mutationOptions =
    getSetAutomationsForTriggerInstance2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Both POST and PUT are accepted at the same path. PUT is preferred and
matches the replace-collection semantics; the POST binding is retained
for backwards compatibility and may be removed in a future version.
 * @summary Attach automations to a trigger instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const setAutomationsForTriggerInstance = (
  organizationId: string,
  workspaceId: string,
  triggerInstanceId: string,
  libraryServiceSetAutomationsForTriggerInstanceBodyBody: LibraryServiceSetAutomationsForTriggerInstanceBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SetAutomationsForTriggerInstanceResponse>> => {
  return axios.default.put(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/triggers/${triggerInstanceId}/automations`,
    libraryServiceSetAutomationsForTriggerInstanceBodyBody,
    options,
  );
};

export const getSetAutomationsForTriggerInstanceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      triggerInstanceId: string;
      data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    triggerInstanceId: string;
    data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
  },
  TContext
> => {
  const mutationKey = ['setAutomationsForTriggerInstance'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>,
    {
      organizationId: string;
      workspaceId: string;
      triggerInstanceId: string;
      data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, triggerInstanceId, data } =
      props ?? {};

    return setAutomationsForTriggerInstance(
      organizationId,
      workspaceId,
      triggerInstanceId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutomationsForTriggerInstanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>
>;
export type SetAutomationsForTriggerInstanceMutationBody =
  LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
export type SetAutomationsForTriggerInstanceMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Attach automations to a trigger instance.
The caller sends the full desired list; the existing list is replaced.
 */
export const useSetAutomationsForTriggerInstance = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        triggerInstanceId: string;
        data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAutomationsForTriggerInstance>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    triggerInstanceId: string;
    data: LibraryServiceSetAutomationsForTriggerInstanceBodyBody;
  },
  TContext
> => {
  const mutationOptions =
    getSetAutomationsForTriggerInstanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns ranked procedures that best match the provided query.
Each result includes the owning book name and version, a full procedure descriptor,
and a relevance score.
 * @summary Searches procedures across all available books.
 */
export const searchBookProcedures = (
  v2SearchBookProceduresRequest: V2SearchBookProceduresRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2SearchBookProceduresResponse>> => {
  return axios.default.post(
    `/api/v1/procedures:search`,
    v2SearchBookProceduresRequest,
    options,
  );
};

export const getSearchBookProceduresMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBookProcedures>>,
    TError,
    { data: V2SearchBookProceduresRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBookProcedures>>,
  TError,
  { data: V2SearchBookProceduresRequest },
  TContext
> => {
  const mutationKey = ['searchBookProcedures'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBookProcedures>>,
    { data: V2SearchBookProceduresRequest }
  > = props => {
    const { data } = props ?? {};

    return searchBookProcedures(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBookProceduresMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBookProcedures>>
>;
export type SearchBookProceduresMutationBody = V2SearchBookProceduresRequest;
export type SearchBookProceduresMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches procedures across all available books.
 */
export const useSearchBookProcedures = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchBookProcedures>>,
      TError,
      { data: V2SearchBookProceduresRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchBookProcedures>>,
  TError,
  { data: V2SearchBookProceduresRequest },
  TContext
> => {
  const mutationOptions = getSearchBookProceduresMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This endpoint returns a consolidated list of all tags used across all books
in the library. Tags are used for categorizing and organizing books by
functionality, domain, or other characteristics.
 * @summary Retrieves all available tags from all books in the library.
 */
export const retrieveTags = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Bdkv2RetrieveTagsResponse>> => {
  return axios.default.get(`/api/v1/tags`, options);
};

export const getRetrieveTagsQueryKey = () => {
  return [`/api/v1/tags`] as const;
};

export const getRetrieveTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof retrieveTags>>,
  TError = AxiosError<RpcStatus>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof retrieveTags>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveTags>>> = ({
    signal,
  }) => retrieveTags({ signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof retrieveTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetrieveTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retrieveTags>>
>;
export type RetrieveTagsQueryError = AxiosError<RpcStatus>;

export function useRetrieveTags<
  TData = Awaited<ReturnType<typeof retrieveTags>>,
  TError = AxiosError<RpcStatus>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveTags>>,
          TError,
          Awaited<ReturnType<typeof retrieveTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveTags<
  TData = Awaited<ReturnType<typeof retrieveTags>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveTags>>,
          TError,
          Awaited<ReturnType<typeof retrieveTags>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRetrieveTags<
  TData = Awaited<ReturnType<typeof retrieveTags>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveTags>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves all available tags from all books in the library.
 */

export function useRetrieveTags<
  TData = Awaited<ReturnType<typeof retrieveTags>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof retrieveTags>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getRetrieveTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This endpoint is not available publicly because Grimoire should be the one calling it internally.
 * @summary Removes a book connection from the library.
This endpoint removes a book connection from the library.
 */
export const removeWorkspaceBookConnection = (
  v2RemoveWorkspaceBookConnectionRequest: V2RemoveWorkspaceBookConnectionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V2RemoveBookConnectionResponse>> => {
  return axios.default.post(
    `/bdk.v2.LibraryService/RemoveWorkspaceBookConnection`,
    v2RemoveWorkspaceBookConnectionRequest,
    options,
  );
};

export const getRemoveWorkspaceBookConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceBookConnection>>,
    TError,
    { data: V2RemoveWorkspaceBookConnectionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeWorkspaceBookConnection>>,
  TError,
  { data: V2RemoveWorkspaceBookConnectionRequest },
  TContext
> => {
  const mutationKey = ['removeWorkspaceBookConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeWorkspaceBookConnection>>,
    { data: V2RemoveWorkspaceBookConnectionRequest }
  > = props => {
    const { data } = props ?? {};

    return removeWorkspaceBookConnection(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveWorkspaceBookConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeWorkspaceBookConnection>>
>;
export type RemoveWorkspaceBookConnectionMutationBody =
  V2RemoveWorkspaceBookConnectionRequest;
export type RemoveWorkspaceBookConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Removes a book connection from the library.
This endpoint removes a book connection from the library.
 */
export const useRemoveWorkspaceBookConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeWorkspaceBookConnection>>,
      TError,
      { data: V2RemoveWorkspaceBookConnectionRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceBookConnection>>,
  TError,
  { data: V2RemoveWorkspaceBookConnectionRequest },
  TContext
> => {
  const mutationOptions =
    getRemoveWorkspaceBookConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
